import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
        >
          <Header />
          <CFView
            mt="30px"
            column
            alignCenter
            justifyEnd
            w="100%"
            textCenter
            mb="10vh"
          >
            <CFImage
              w="90%"
              src={mobileHeroText}
              alt="Ginger Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) 20% 0%/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="80px" mt="140px">
            <CFImage
              w="500px"
              src={heroText}
              alt="Ginger Sushi hero text"
              zIndex={98}
            />
            <CFView pulsate mt="30px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
